<router-outlet />
<osf-toast></osf-toast>
<osf-full-screen-loader></osf-full-screen-loader>
